import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react'

interface WizardNavigationProps {
  isFirstStep: boolean
  isLastStep: boolean
  isLoading?: boolean
  onPrev: () => void
  onNext: () => Promise<boolean>
  onSubmit?: () => void
  submitLabel?: string
}

export function WizardNavigation({
  isFirstStep,
  isLastStep,
  isLoading = false,
  onPrev,
  onNext,
  onSubmit,
  submitLabel = 'Crear Cliente',
}: WizardNavigationProps) {
  const handleNext = async () => {
    if (isLastStep && onSubmit) {
      onSubmit()
    } else {
      await onNext()
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 pt-4 border-t">
      <Button
        type="button"
        variant="outline"
        onClick={onPrev}
        disabled={isFirstStep || isLoading}
        className="gap-2"
      >
        <ChevronLeft className="h-4 w-4" />
        <span className="hidden sm:inline">Anterior</span>
      </Button>

      <Button
        type="button"
        onClick={handleNext}
        disabled={isLoading}
        className="gap-2"
      >
        {isLoading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Guardando...</span>
          </>
        ) : isLastStep ? (
          submitLabel
        ) : (
          <>
            <span className="hidden sm:inline">Siguiente</span>
            <span className="sm:hidden">Sig.</span>
            <ChevronRight className="h-4 w-4" />
          </>
        )}
      </Button>
    </div>
  )
}
